<template>
  <v-row>
    <v-col cols="3">
      <StudentDetailCard></StudentDetailCard>
      <StudentClassesDetail class="mt-3" v-if="studentBlendedTutorDetail"></StudentClassesDetail>
    </v-col>
    <v-col cols="9" style="padding-left: 0;">
      <template v-if="!isShowSortClassTutor && !isShowChangeOperatorSection">
        <DuoStudentDetail v-if="activeFilterType === 3" class="mt-4"/>
        <StudentHistoryCard v-if="studentBlendedTutorDetail && activeFilterType === 1" @show-detail-special-care="handleShowDetailSpecialCare"></StudentHistoryCard>
        <StudentBulletinBoardVue v-if="activeFilterType === 2"/>
        <TakePartInRate class="mt-3" v-if="studentBlendedTutorDetail && activeFilterType === 1"></TakePartInRate>
      </template>
<!--      <TutorStudentDetail class="mt-2"></TutorStudentDetail>-->
      <CareHistoryCard
        ref="careHistoryCard"
        v-if="studentBlendedTutorDetail"
        :recordDetail="studentBlendedTutorDetail"
        class="mt-3 mb-3"></CareHistoryCard>
    </v-col>
  </v-row>
</template>

<script>
// import TutorStudentDetail from '@/modules/student_detail_bt/components/TutorStudentDetail.vue';
import CareHistoryCard from '@/modules/student_detail_bt/components/CareHistoryCard.vue';
// import NoteCard from '@/modules/student_detail_bt/components/NoteCard.vue';
import TakePartInRate from '@/modules/student_detail_bt/components/TakePartInRate.vue';
import StudentHistoryCard from '@/modules/student_detail_bt/components/StudentHistoryCard.vue';
import StudentClassesDetail from '@/modules/student_detail_bt/components/StudentClassesDetail.vue';
import StudentDetailCard from '@/modules/student_detail_bt/components/StudentDetailCard.vue';
import DuoStudentDetail from '@/modules/student_detail_bt/components/DuoStudentDetail.vue';
import { mapGetters, mapState } from 'vuex';
import { STUDENT_DETAIL_BLENDED_TAB_INDEX } from '@/modules/student_detail_bt/constant';
import { SORT_CLASS_PROGRAMS_NAME } from '@/modules/student_care/constant/constant';
import StudentBulletinBoardVue from './components/StudentBulletinBoard/index.vue';

export default {
  name: 'StudentDetail.vue',
  data() {
    return {
      SORT_CLASS_PROGRAMS_NAME,
      windowWidth: window.innerWidth,
    };
  },
  // beforeRouteEnter(to, from) {
  //   console.log(to, from);
  // },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    handleShowDetailSpecialCare() {
      this.$refs.careHistoryCard.tab = STUDENT_DETAIL_BLENDED_TAB_INDEX.LOG;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  components: {
    CareHistoryCard,
    TakePartInRate,
    StudentDetailCard,
    StudentClassesDetail,
    StudentHistoryCard,
    // TutorStudentDetail,
    DuoStudentDetail,
    StudentBulletinBoardVue,
    // NoteCard,
  },
  computed: {
    ...mapState('student_detail_bt', ['activeFilterType', 'studentBlendedTutorDetail']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapGetters('contact_status', ['mapCallStatus']),
    isShowSortClassTutor() {
      return (_.get(this.mapCallStatus, `[${_.get(this.studentBlendedTutorDetail, 'call_status_id', -1)}].callType`, '') === 'TA0'
        && _.get(this.studentBlendedTutorDetail, 'careTagsMongo', []).some((e) => e.name === 'Chờ xếp lớp')
        && SORT_CLASS_PROGRAMS_NAME.includes(_.get(this.mapProgramIdAndProgram[this.studentBlendedTutorDetail.curriculum_id], 'title', ''))
        && this.$route.query.schoolLevel === 'primary');
    },
    isShowChangeOperatorSection() {
      return (_.get(this.mapCallStatus, `[${_.get(this.studentBlendedTutorDetail, 'call_status_id', -1)}].callType`, '') === 'TA0'
        && _.get(this.studentBlendedTutorDetail, 'careTagsMongo', []).some((e) => e.name === 'Chuyển vận hành')
        && SORT_CLASS_PROGRAMS_NAME.includes(_.get(this.mapProgramIdAndProgram[this.studentBlendedTutorDetail.curriculum_id], 'title', ''))
        && this.$route.query.schoolLevel === 'primary');
    },
  },
};
</script>

<style scoped>

</style>
